module.exports = __webpack_public_path__ + "img/bg.e4955de9.jpg";